import React from "react";
import moment from "moment";
import Day from "./Day";
const days = ["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat"];

export default function Weekly() {
  return (
    <div style={{ height: "100%", display: "flex", flexFlow: "column" }}>
      <div style={{ fontSize: 30 }}>{moment().format("dddd MMMM D")}</div>
      <div style={{ display: "flex" }}>
        {[...new Array(7)].map((_, i) => (
          <div style={{ width: `${100 / 7}%`, textAlign: "center" }}>
            {days[(moment().day() + i) % 7]}
          </div>
        ))}
      </div>
      <div style={{ flexGrow: 1, overflowY: "scroll" }}>
        <div style={{ display: "flex", height: "100%" }}>
          {[...new Array(7)].map((_, i) => (
            <Day day={moment().add(i, "days").toISOString()} />
          ))}
        </div>
      </div>
    </div>
  );
}
